export class PersonalInformation {
  public firstName: string;
  public lastName: string;
  public business: string;
  public company: string;
  public position: string;
  public country: string;
  public city: string;
  public subscribe: boolean;

  constructor(json: any) {
    this.firstName = json.firstName || '';
    this.lastName = json.lastName || '';
    this.business = json.business || '';
    this.company = json.company || '';
    this.position = json.position || '';
    this.country = json.country || '';
    this.city = json.city || '';

    this.subscribe = json.subscribe || false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/personal-information.ts